import script from "./usersWalletTransactions.vue?vue&type=script&setup=true&lang=js"
export * from "./usersWalletTransactions.vue?vue&type=script&setup=true&lang=js"

import "./usersWalletTransactions.vue?vue&type=style&index=0&id=7fcbe302&lang=css"

const __exports__ = script;

export default __exports__